import { NgModule } from '@angular/core';
import { BmsjHipsterSharedModule } from '../../shared';
import { RouterModule } from '@angular/router';
import { LocationComponent, LocationPopupComponent } from './location.component';
import { BREEDING_LOCATION_ROUTES } from './location.route';

@NgModule({
    imports: [
        BmsjHipsterSharedModule,
        RouterModule.forChild([...BREEDING_LOCATION_ROUTES]),
    ],
    declarations: [
        LocationComponent,
        LocationPopupComponent
    ]
})
export class LocationModule {

}
